<template>
  <v-app>
    <v-container class="pt-0" fluid>
      <v-row>
        <v-col class="pt-0">
          <h1>Digitaler Abfallkalender</h1>
          <p>Wann wird welche Tonne geleert und wo kann Gr&uuml;nschnitt abgegeben werden? Der digitale Abfallkalender kennt die Antwort – geben Sie Ihre Straße ein, w&auml;hlen Sie die entsprechende Abfallsorte aus und speichern Sie die Termine in Ihrem digitalen Kalender.</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col :cols="6" id="autocompleteStreet">
          <b>Straße eingeben</b><br /><br />
          <v-autocomplete outlined dense attach="#autocompleteStreet" v-model="select" :loading="loading" :items="items" :search-input.sync="search" item-text="streetname" item-value="uid" flat hide-no-data hide-details label="Eingabe" auto-select-first @change="updateCalendar"></v-autocomplete> </v-col
        ><v-col class="d-flex d-sm-none" :cols="1" id="autocompleteStreet"><v-icon class="mt-8" v-if="selectedStreet.length != 0" color="primary"> mdi-check </v-icon></v-col>
        <v-col :cols="12">
          <v-expansion-panels multiple>
            <v-expansion-panel>
              <v-expansion-panel-header> Abfallsorte ausw&auml;hlen </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col :cols="12" :sm="6"> <v-checkbox value="6" v-model="checkboxRestmuell" @change="showAndHideSpuelung"></v-checkbox><img class="mr-2" src="../src/assets/icons/restmuell.svg" />Restm&uuml;ll</v-col>
                  <v-col :cols="12" :sm="6"> <v-checkbox value="5" v-model="checkboxGelbeTonne" @change="filterByGarbageType"></v-checkbox><img class="mr-2" src="../src/assets/icons/gelbetonne.svg" />Gelbe Tonne/Gelber Sack</v-col>
                </v-row>
                <v-row>
                  <v-col :cols="12" :sm="6"><v-checkbox value="7" v-model="checkboxBrauneTonne" @change="showAndHideSpuelung"></v-checkbox><img class="mr-2" src="../src/assets/icons/braunetonne.svg" />Braune Tonne</v-col>
                  <v-col :cols="12" :sm="6"><v-checkbox value="8" v-model="checkboxBlaueTonne" @change="filterByGarbageType"></v-checkbox><img class="mr-2" src="../src/assets/icons/blauetonne.svg" />Blaue Tonne</v-col>
                </v-row>
                <v-row>
                  <v-col :cols="12" :sm="6"><v-checkbox value="9" v-model="checkboxBaum" @change="filterByGarbageType"></v-checkbox><img class="mr-2" src="../src/assets/icons/tannenbaum.svg" />Weihnachtsbaumabfuhr</v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header> Sondertermine anzeigen </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col :cols="12"
                    ><v-checkbox value="2" v-model="checkboxSchadstoff" @change="filterByGarbageType"></v-checkbox>
                    <ul class="schadstoff">
                      <li>
                        Schadstoffmobil, Wertstoffhof, Am Knipprather Busch 10<br />
                        Öffnungszeiten: Sa 9 – 15 Uhr
                      </li>
                    </ul></v-col
                  >
                </v-row>
                <v-row>
                  <v-col :cols="12"
                    ><v-checkbox value="3" v-model="checkboxGruenschnitt" @change="filterByGarbageType"></v-checkbox>
                    <ul class="gruenschnitt">
                      <li>Zusätzliche Grünschnittabgabe auf dem Parkplatz der Bürgerwiese „Am Kielsgraben“</li>
                    </ul></v-col
                  >
                </v-row>
                <v-row>
                  <v-col :cols="12">
                    <v-checkbox value="1" v-model="checkboxWertstoff" @change="filterByGarbageType"></v-checkbox>
                    <ul class="wertstoff">
                      <li>Wertstoffhof, Am Knipprather Busch 10<br />Öffnungszeiten: Di und Do 12 – 18 Uhr, Sa 9 – 15 Uhr</li>
                    </ul>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col :cols="12"
                    ><v-checkbox value="4" v-model="checkboxSpuelung" @change="hideTonneIfSpuelungIsDeactivated"></v-checkbox>
                    <ul class="spuelung">
                      <li>Leerung und Spülung der Biotonnen</li>
                    </ul></v-col
                  >
                </v-row>
                <v-row>
                  <v-col :cols="12"
                    ><v-checkbox value="0" v-model="checkboxSpuelungRestmuell" @change="hideTonneIfSpuelungIsDeactivated"></v-checkbox>
                    <ul class="spuelung-restmuell">
                      <li>Leerung und Spülung der Restmülltonnen</li>
                    </ul></v-col
                  >
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
        <v-col>
          <v-tabs background-color="transparent" v-model="tab">
            <v-tab href="#kalender"> Kalenderansicht </v-tab>
            <v-tab href="#liste"> Listenansicht </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item value="kalender">
              <v-card>
                <v-sheet height="64">
                  <v-toolbar flat>
                    <v-btn fab text small color="grey darken-2" @click="prev">
                      <v-icon small> mdi-chevron-left </v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-toolbar-title class="text-center" v-if="$refs.calendar">
                      <b>{{ $refs.calendar.title }} </b><br />
                      <v-btn outlined class="today-button" @click="setToday"> heute </v-btn>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn fab text small color="grey darken-2" @click="next">
                      <v-icon small> mdi-chevron-right </v-icon>
                    </v-btn>
                  </v-toolbar>
                </v-sheet>
                <v-sheet>
                  <v-calendar locale="de" ref="calendar" v-model="focus" color="#0098db" :events="events" event-color="transparent" :type="type" :event-more="false" event-more-text="mehr" weekdays="1, 2, 3, 4, 5, 6,0 " @change="filterByGarbageType" @click:event="showEvent" @click:date="viewDay" @click:more="viewDay">
                    <template v-slot:event="{ event }">
                      <div class="text-center">
                        <img v-if="event.garbageType == '1'" src="../src/assets/icons/wertstoff.png" />
                        <img v-if="event.garbageType == '2'" src="../src/assets/icons/schadstoff.png" />
                        <img v-if="event.garbageType == '9'" src="../src/assets/icons/tannenbaum.svg" />
                        <img v-if="event.garbageType == '4' && !event.icon" src="../src/assets/icons/spülung.png" />
                        <img v-if="event.garbageType == '5'" src="../src/assets/icons/gelbetonne.svg" />
                        <img v-if="event.garbageType == '6' || event.icon === 'rmt'" src="../src/assets/icons/restmuell.svg" />
                        <img v-if="event.garbageType == '7' || event.icon === 'bt'" src="../src/assets/icons/braunetonne.svg" />
                        <img v-if="event.garbageType == '8'" src="../src/assets/icons/blauetonne.svg" />
                        <img v-if="event.garbageType == '3'" src="../src/assets/icons/gruenschnitt.png" />
                        <img v-if="event.garbageType == '0' && !event.icon" src="../src/assets/icons/spuelung_restmuell.png" />
                      </div> </template
                  ></v-calendar>
                </v-sheet>
                <v-dialog v-model="selectedOpen" :close-on-content-click="true" max-width="500" :activator="{ selectedElement }">
                  <v-card class="event-detail" color="#E7F5FC" flat>
                    <v-card-text>
                      <v-row>
                        <v-col :cols="12"
                          ><b>{{ selectedEvent.start | moment("dddd") }},<br />{{ selectedEvent.start | moment("DD. MMMM YYYY") }}</b>
                          <v-btn icon dark @click="selectedOpen = false" style="position: absolute; top: 10px; right: 10px">
                            <v-icon>mdi-close</v-icon>
                          </v-btn></v-col
                        >
                        <v-col :cols="6"
                          ><img v-if="selectedEvent.garbageType == '1'" src="../src/assets/icons/wertstoff.png" />
                          <img v-if="selectedEvent.garbageType == '2'" src="../src/assets/icons/schadstoff.png" />
                          <img v-if="selectedEvent.garbageType == '9'" src="../src/assets/icons/tannenbaum.svg" />
                          <img v-if="selectedEvent.garbageType == '4' && !selectedEvent.icon" src="../src/assets/icons/spülung.png" />
                          <img v-if="selectedEvent.garbageType == '5'" src="../src/assets/icons/gelbetonne.svg" />
                          <img v-if="selectedEvent.garbageType == '6' || selectedEvent.icon === 'rmt'" src="../src/assets/icons/restmuell.svg" />
                          <img v-if="selectedEvent.garbageType == '7' || selectedEvent.icon === 'bt'" src="../src/assets/icons/braunetonne.svg" />
                          <img v-if="selectedEvent.garbageType == '8'" src="../src/assets/icons/blauetonne.svg" />
                          <img v-if="selectedEvent.garbageType == '3'" src="../src/assets/icons/gruenschnitt.png" />
                          <img v-if="selectedEvent.garbageType == '0' && !selectedEvent.icon" src="../src/assets/icons/spuelung_restmuell.png" />
                          {{ selectedEvent.name }}</v-col
                        >
                        <v-col :cols="6"
                          ><v-btn outlined small v-on:click="createSingleIcs(selectedEvent)" class="ical-download">
                            <img src="../src/assets/icons/download.svg" class="caldownload-icon" />
                            iCal Termin
                          </v-btn></v-col
                        >
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-dialog>
                <v-dialog v-model="selectedOpenDay" :close-on-content-click="true" max-width="500">
                  <v-card class="event-detail" color="#E7F5FC" flat>
                    <v-card-text>
                      <v-row v-for="(eventByDay, eventIndex) in eventsByDay" v-bind:key="eventIndex">
                        <v-col :cols="12"
                          ><b v-if="eventIndex == 0">{{ eventByDay.start | moment("dddd") }},<br />{{ eventByDay.start | moment("DD. MMMM YYYY") }}</b>
                          <v-btn v-if="eventIndex == 0" icon dark @click="selectedOpenDay = false" style="position: absolute; top: 10px; right: 10px">
                            <v-icon>mdi-close</v-icon>
                          </v-btn></v-col
                        >
                        <v-col :cols="6"
                          ><img v-if="eventByDay.garbageType == '1'" src="../src/assets/icons/wertstoff.png" />
                          <img v-if="eventByDay.garbageType == '2'" src="../src/assets/icons/schadstoff.png" />
                          <img v-if="eventByDay.garbageType == '9'" src="../src/assets/icons/tannenbaum.svg" />
                          <img v-if="eventByDay.garbageType == '4' && !eventByDay.icon" src="../src/assets/icons/spülung.png" />
                          <img v-if="eventByDay.garbageType == '5'" src="../src/assets/icons/gelbetonne.svg" />
                          <img v-if="eventByDay.garbageType == '6' || eventByDay.icon === 'rmt'" src="../src/assets/icons/restmuell.svg" />
                          <img v-if="eventByDay.garbageType == '7' || eventByDay.icon === 'bt'" src="../src/assets/icons/braunetonne.svg" />
                          <img v-if="eventByDay.garbageType == '8'" src="../src/assets/icons/blauetonne.svg" />
                          <img v-if="eventByDay.garbageType == '3'" src="../src/assets/icons/gruenschnitt.png" />
                          <img v-if="eventByDay.garbageType == '0' && !eventByDay.icon" src="../src/assets/icons/spuelung_restmuell.png" />
                          {{ eventByDay.name }}</v-col
                        >
                        <v-col :cols="6"
                          ><v-btn outlined small v-on:click="createSingleIcs(eventByDay)" class="ical-download">
                            <img src="../src/assets/icons/download.svg" class="caldownload-icon" />
                            iCal Termin
                          </v-btn></v-col
                        >
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </v-card>
            </v-tab-item>
            <v-tab-item value="liste">
              <v-card>
                <v-sheet height="64">
                  <v-toolbar flat>
                    <v-btn fab text small color="grey darken-2" @click="prev">
                      <v-icon small> mdi-chevron-left </v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-toolbar-title class="text-center" v-if="$refs.calendar">
                      <b>{{ $refs.calendar.title }} </b><br />
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn fab text small color="grey darken-2" @click="next">
                      <v-icon small> mdi-chevron-right </v-icon>
                    </v-btn>
                  </v-toolbar> </v-sheet
                ><v-sheet>
                  <v-container fluid>
                    <div v-for="(day, index) in eventsByMonth" class="day" v-bind:key="index">
                      <v-row class="list-date-item" v-for="(event, indexEvent) in day" v-bind:key="indexEvent">
                        <v-col :cols="12" class="date"
                          ><b v-if="indexEvent == 0">{{ event.start | moment("dddd") }},<br />{{ event.start | moment("DD. MMMM YYYY") }}</b></v-col
                        >
                        <v-col class="garbage" :cols="6"
                          ><img v-if="event.garbageType == '1'" src="../src/assets/icons/wertstoff.png" />
                          <img v-if="event.garbageType == '2'" src="../src/assets/icons/schadstoff.png" />
                          <img v-if="event.garbageType == '9'" src="../src/assets/icons/tannenbaum.svg" />
                          <img v-if="event.garbageType == '4' && !event.icon" src="../src/assets/icons/spülung.png" />
                          <img v-if="event.garbageType == '5'" src="../src/assets/icons/gelbetonne.svg" />
                          <img v-if="event.garbageType == '6' || event.icon === 'rmt'" src="../src/assets/icons/restmuell.svg" />
                          <img v-if="event.garbageType == '7' || event.icon === 'bt'" src="../src/assets/icons/braunetonne.svg" />
                          <img v-if="event.garbageType == '8'" src="../src/assets/icons/blauetonne.svg" />
                          <img v-if="event.garbageType == '3'" src="../src/assets/icons/gruenschnitt.png" />
                          <img v-if="event.garbageType == '0' && !event.icon" src="../src/assets/icons/spuelung_restmuell.png" />
                          {{ event.name }}<br
                        /></v-col>

                        <v-col class="cal-export" :cols="6"
                          ><v-btn outlined small v-on:click="createSingleIcs(event)" class="ical-download">
                            <img src="../src/assets/icons/download.svg" class="caldownload-icon" />
                            iCal Termin
                          </v-btn></v-col
                        >
                      </v-row>
                    </div>
                  </v-container>
                </v-sheet></v-card
              ></v-tab-item
            >
          </v-tabs-items>
        </v-col>
        <v-col :cols="12">
          <b>Alle Termine herunterladen</b>
          <br />
          <v-btn outlined small href="https://www.monheim.de/fileadmin/user_upload/Media/Dokumente_NEU/60_Bauwesen/02_Bauverwaltung_Abfall/Stadt_Monheim_am_Rhein_2026-Abfallkalender.pdf	" target="_blank" class="ical-download"><img class="caldownload-icon" src="../src/assets/icons/pdf.svg" height="25" width="18" /> Jahreskalender 2026</v-btn>
          <v-btn outlined small v-on:click="createFullIcs" class="ical-download"><img class="caldownload-icon" src="../src/assets/icons/download.svg" height="18" width="19" /> iCal Termine</v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </v-app>
</template>

<script>
import moment from "moment";
export default {
  name: "App",
  data: () => ({
    autocompleteAttach: "#autocompleteStreet",
    tab: null,
    overlay: false,
    loading: false,
    restmuellManipulated: false,
    biotonneManipulated: false,
    items: [],
    search: null,
    select: null,
    streets: [],
    collectionDates: [],
    focus: moment(),
    type: "month",
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    selectedOpenDay: false,
    selectedStreet: [],
    events: [],
    checkboxRestmuell: null,
    checkboxGelbeTonne: null,
    checkboxBrauneTonne: null,
    checkboxBlaueTonne: null,
    checkboxBaum: null,
    checkboxSchadstoff: null,
    checkboxGruenschnitt: null,
    checkboxWertstoff: null,
    checkboxSpuelung: null,
    checkboxSpuelungRestmuell: null,
  }),
  watch: {
    search(val) {
      val && val !== this.select && this.querySelections(val);
    },
  },
  computed: {
    eventsByMonth: function () {
      let focus = this.focus;
      let events = this.events.filter(function (event) {
        if (moment(event.start).format("YYYY-MM") == moment(focus).format("YYYY-MM")) {
          return event;
        }
      });
      return this.groupBy(events, "start");
    },
    eventsByDay: function () {
      let focus = this.focus;
      let events = this.events.filter(function (event) {
        if (moment(event.start).format("YYYY-MM-DD") == moment(focus).format("YYYY-MM-DD")) {
          return event;
        }
      });
      return events;
    },
  },
  mounted() {
    this.getStreets();
    this.getCollectionDates();
  },
  methods: {
    querySelections(v) {
      this.loading = true;
      // Simulated ajax query
      setTimeout(() => {
        this.items = this.streets.filter((e) => {
          return (e.streetname || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1;
        });
        this.loading = false;
      }, 500);
    },
    getStreets() {
      this.overlay = true;
      this.axios.get("https://www.monheim.de/?type=1106181").then((response) => {
        this.streets = response.data.streets;
      });
      this.overlay = false;
    },
    getCollectionDates() {
      this.overlay = true;
      this.axios.get("https://www.monheim.de/?type=1106182").then((response) => {
        this.collectionDates = response.data.collectiondates;
        this.updateCalendarFirstLoad();
      });
      this.overlay = false;
    },
    viewDay({ date }) {
      const open = () => {
        this.focus = date;
        setTimeout(() => {
          this.selectedOpenDay = true;
        }, 10);
      };

      if (this.selectedOpenDay) {
        this.selectedOpenDay = false;
        setTimeout(open, 10);
      } else {
        open();
      }
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => {
          this.selectedOpen = true;
        }, 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    updateCalendarFirstLoad() {
      this.overlay = true;
      const events = [];

      this.collectionDates.forEach((colDate) => {
        let garbageType = "";
        switch (colDate.garbageTypes) {
          case "1":
            garbageType = "Wertstoffhof";
            break;
          case "2":
            garbageType = "Schadstoff Mobil";
            break;
          case "9":
            garbageType = "zusätzliche Grünabgabe";
            break;
          case "4":
            garbageType = "Spülung und Leerung der Biotonnen";
            break;
          case "5":
            garbageType = "Gelber Sack";
            break;
          case "6":
            garbageType = "Restmüll";
            break;
          case "7":
            garbageType = "Braune Tonne";
            break;
          case "8":
            garbageType = "Blaue Tonne";
            break;
          case "3":
            garbageType = "Grünabfälle";
            break;
          case "0":
            garbageType = "Spülung und Leerung der Restmülltonnen";
            break;
          default:
          // code block
        }
        if (colDate.garbageTypes == 0) {
          events.push({
            name: "Spülung und Leerung der Restmülltonnen",
            start: colDate.dateOfCollection,
            end: colDate.dateOfCollection,
            timed: false,
            garbageType: colDate.garbageTypes,
            districts: colDate.districts,
            specialDate: colDate.isSpecialDate,
            icon: "rmt",
          });
          events.push({
            name: garbageType,
            start: colDate.dateOfCollection,
            end: colDate.dateOfCollection,
            timed: false,
            garbageType: colDate.garbageTypes,
            districts: colDate.districts,
            specialDate: colDate.isSpecialDate,
          });
        } else if (colDate.garbageTypes == 4) {
          events.push({
            name: "Spülung und Leerung der Biotonnen",
            start: colDate.dateOfCollection,
            end: colDate.dateOfCollection,
            timed: false,
            garbageType: colDate.garbageTypes,
            districts: colDate.districts,
            specialDate: colDate.isSpecialDate,
            icon: "bt",
          });
          events.push({
            name: garbageType,
            start: colDate.dateOfCollection,
            end: colDate.dateOfCollection,
            timed: false,
            garbageType: colDate.garbageTypes,
            districts: colDate.districts,
            specialDate: colDate.isSpecialDate,
          });
        } else {
          events.push({
            name: garbageType,
            start: colDate.dateOfCollection,
            end: colDate.dateOfCollection,
            timed: false,
            garbageType: colDate.garbageTypes,
            districts: colDate.districts,
            specialDate: colDate.isSpecialDate,
          });
        }
      });
      this.events = events;
      this.overlay = false;
    },
    updateCalendar() {
      this.findSelectedStreet();
      this.updateCalendarFirstLoad();
      let selectedStreetDistricts = this.selectedStreet.district.split(",");

      if (selectedStreetDistricts.length == 2) {
        const events = [];
        this.events.filter((event) => {
          let districts = event.districts.split(",");
          districts.forEach((district) => {
            if (district == selectedStreetDistricts[0]) {
              if (event.garbageType == "6" || event.garbageType == "0" || event.garbageType == "7" || event.garbageType == "9" || event.garbageType == "4") {
                events.push(event);
              }
            }
            if (district == selectedStreetDistricts[1]) {
              if (event.garbageType == "5" || event.garbageType == "8") {
                //new special rule for yellow trash on year 2024
                if (this.selectedStreet.specialyellowgarbage && event.garbageType == "5") {
                  //manipulate date if day is wednesday
                  if (moment(event.start).isoWeekday() === 3) {
                    event.start = moment(event.start).add(1, "d").format("YYYY-MM-DD");
                    event.end = moment(event.end).add(1, "d").format("YYYY-MM-DD");
                    events.push(event);
                  } else {
                    events.push(event);
                  }
                } else {
                  events.push(event);
                }
              }
            }
          });
          if (event.specialDate == true) {
            events.push(event);
          }
        });
        this.events = events;
      } else {
        const events = [];
        this.events.filter((event) => {
          let districts = event.districts.split(",");
          districts.forEach((district) => {
            if (district == this.selectedStreet.district) {
              //new special rule for yellow trash on year 2024
              if (this.selectedStreet.specialyellowgarbage && event.garbageType == "5") {
                //manipulate date if day is wednesday
                if (moment(event.start).isoWeekday() === 3) {
                  event.start = moment(event.start).add(1, "d").format("YYYY-MM-DD");
                  event.end = moment(event.end).add(1, "d").format("YYYY-MM-DD");
                  events.push(event);
                } else {
                  events.push(event);
                }
              } else {
                events.push(event);
              }
            }
          });
          if (event.specialDate == true) {
            events.push(event);
          }
        });
        this.events = events;
      }
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
    createSingleIcs(selectedEvent) {
      if (selectedEvent.garbageType == "2") {
        this.overlay = true;
        let language = "de-de";
        let subject = selectedEvent.name;
        let fileName = subject + "-" + moment(selectedEvent.start).format("YYYY-MM-DD");
        let description = "Wertstoffhof Am Knipprather Busch 10 Öffnungszeiten: Sa 9 – 15 Uhr";
        let location = "Monheim am Rhein";
        let start = new Date(selectedEvent.start + "T09:00:00");
        let end = new Date(selectedEvent.end + "T15:00:00");
        let url = "monheim.de";
        // let organizer = {
        //   name: "Stadt Monheim am Rhein",
        //   email: "info@monheim.de",
        // };
        this.$ics.addEvent(language, subject, description, location, start, end, url, null, null);
        this.$ics.download(fileName);
        this.$ics.removeAllEvents();
        this.overlay = false;
      } else if (selectedEvent.garbageType == "1") {
        this.overlay = true;
        let language = "de-de";
        let subject = selectedEvent.name;
        let fileName = subject + "-" + moment(selectedEvent.start).format("YYYY-MM-DD");
        let description = "Am Knipprather Busch 10 Öffnungszeiten: Di, Do und Fr 12 – 18 Uhr, Sa 9 – 15 Uhr";
        let location = "Monheim am Rhein";
        if (new Date(selectedEvent.start).getDay() == 2 || new Date(selectedEvent.start).getDay() == 4 || new Date(selectedEvent.start).getDay() == 5) {
          let start = new Date(selectedEvent.start + "T12:00:00");
          let end = new Date(selectedEvent.end + "T18:00:00");
          let url = "monheim.de";
          // let organizer = {
          //   name: "Stadt Monheim am Rhein",
          //   email: "info@monheim.de",
          // };
          this.$ics.addEvent(language, subject, description, location, start, end, url, null, null);
          this.$ics.download(fileName);
          this.$ics.removeAllEvents();
          this.overlay = false;
        }
        if (new Date(selectedEvent.start).getDay() == 6) {
          let start = new Date(selectedEvent.start + "T09:00:00");
          let end = new Date(selectedEvent.end + "T15:00:00");
          let url = "monheim.de";
          // let organizer = {
          //   name: "Stadt Monheim am Rhein",
          //   email: "info@monheim.de",
          // };
          this.$ics.addEvent(language, subject, description, location, start, end, url, null, null);
          this.$ics.download(fileName);
          this.$ics.removeAllEvents();
          this.overlay = false;
        }
      } else {
        this.overlay = true;
        let language = "de-de";
        let subject = selectedEvent.name;
        let fileName = subject + "-" + moment(selectedEvent.start).format("YYYY-MM-DD");
        let description = "";
        let location = "Monheim am Rhein";
        let start = new Date(selectedEvent.start + "T06:00:00");
        let end = new Date(selectedEvent.end + "T08:00:00");
        let url = "monheim.de";
        // let organizer = {
        //   name: "Stadt Monheim am Rhein",
        //   email: "info@monheim.de",
        // };
        this.$ics.addEvent(language, subject, description, location, start, end, url, null, null);
        this.$ics.download(fileName);
        this.$ics.removeAllEvents();
        this.overlay = false;
      }
    },
    createFullIcs() {
      this.overlay = true;
      let fileName = "Abfuhrkalender-" + moment(new Date()).format("YYYY");
      this.events.forEach((event) => {
        if (event.garbageType == "2") {
          let language = "de-de";
          let subject = event.name;
          let description = "Wertstoffhof Am Knipprather Busch 10 Öffnungszeiten: Sa 9 – 15 Uhr";
          let location = "Monheim am Rhein";
          let start = new Date(event.start + "T09:00:00");
          let end = new Date(event.end + "T15:00:00");
          let url = "monheim.de";
          // let organizer = {
          //   name: "Stadt Monheim am Rhein",
          //   email: "info@monheim.de",
          // };
          this.$ics.addEvent(language, subject, description, location, start, end, url, null, null);
        } else if (event.garbageType == "1") {
          let language = "de-de";
          let subject = event.name;
          let description = "Am Knipprather Busch 10 Öffnungszeiten: Di, Do und Fr 12 – 18 Uhr, Sa 9 – 15 Uhr";
          let location = "Monheim am Rhein";
          if (new Date(event.start).getDay() == 2 || new Date(event.start).getDay() == 4 || new Date(event.start).getDay() == 5) {
            let start = new Date(event.start + "T12:00:00");
            let end = new Date(event.end + "T18:00:00");
            let url = "monheim.de";
            // let organizer = {
            //   name: "Stadt Monheim am Rhein",
            //   email: "info@monheim.de",
            // };
            this.$ics.addEvent(language, subject, description, location, start, end, url, null, null);
          }
          if (new Date(event.start).getDay() == 6) {
            let start = new Date(event.start + "T09:00:00");
            let end = new Date(event.end + "T15:00:00");
            let url = "monheim.de";
            // let organizer = {
            //   name: "Stadt Monheim am Rhein",
            //   email: "info@monheim.de",
            // };
            this.$ics.addEvent(language, subject, description, location, start, end, url, null, null);
          }
        } else if (event.garbageType !== "2" || event.garbageType !== "1") {
          let language = "de-de";
          let subject = event.name;
          let description = "";
          let location = "Monheim am Rhein";
          let start = new Date(event.start + "T06:00:00");
          let end = new Date(event.end + "T08:00:00");

          let url = "monheim.de";
          // let organizer = {
          //   name: "Stadt Monheim am Rhein",
          //   email: "info@monheim.de",
          // };
          this.$ics.addEvent(language, subject, description, location, start, end, url, null, null);
        }
      });
      this.$ics.download(fileName);
      this.$ics.removeAllEvents();
      this.overlay = false;
    },
    findSelectedStreet() {
      this.streets.filter((street) => {
        if (street.uid == this.select) {
          this.selectedStreet = street;
        }
      });
    },
    filterByGarbageType() {
      if (this.checkboxRestmuell == null && this.checkboxGelbeTonne == null && this.checkboxBrauneTonne == null && this.checkboxBlaueTonne == null && this.checkboxBaum == null && this.checkboxSchadstoff == null && this.checkboxWertstoff == null && this.checkboxSpuelung == null && this.checkboxGruenschnitt == null && this.checkboxSpuelungRestmuell == null) {
        this.updateCalendarFirstLoad();
        this.updateCalendar();
      } else {
        this.updateCalendarFirstLoad();
        this.updateCalendar();

        const events = [];
        this.events.filter((event) => {
          if (event.garbageType.includes(this.checkboxRestmuell) || event.garbageType.includes(this.checkboxGelbeTonne) || event.garbageType.includes(this.checkboxBrauneTonne) || event.garbageType.includes(this.checkboxBlaueTonne) || event.garbageType.includes(this.checkboxBaum) || event.garbageType.includes(this.checkboxSchadstoff) || event.garbageType.includes(this.checkboxWertstoff) || event.garbageType.includes(this.checkboxSpuelung) || event.garbageType.includes(this.checkboxGruenschnitt) || event.garbageType.includes(this.checkboxSpuelungRestmuell)) {
            events.push(event);
          }
        });
        this.events = events;
      }
    },
    showAndHideSpuelung() {
      if (this.checkboxRestmuell == "6") {
        this.checkboxSpuelungRestmuell = "0";
      } else {
        this.checkboxSpuelungRestmuell = null;
        this.checkboxRestmuell = null;
      }
      if (this.checkboxBrauneTonne == "7") {
        this.checkboxSpuelung = "4";
      } else {
        this.checkboxSpuelung = null;
        this.checkboxBrauneTonne = null;
      }
      this.filterByGarbageType();
    },
    hideTonneIfSpuelungIsDeactivated() {
      if (this.checkboxSpuelungRestmuell == "0") {
        this.checkboxRestmuell = "6";
      } else {
        this.checkboxSpuelungRestmuell = null;
        this.checkboxRestmuell = null;
      }
      if (this.checkboxSpuelung == "4") {
        this.checkboxBrauneTonne = "7";
      } else {
        this.checkboxSpuelung = null;
        this.checkboxBrauneTonne = null;
      }
      this.filterByGarbageType();
    },
    groupBy(array, key) {
      const result = {};
      array.forEach((item) => {
        if (!result[item[key]]) {
          result[item[key]] = [];
        }
        result[item[key]].push(item);
      });
      return result;
    },
    enumerateDaysBetweenDates(startDate, endDate) {
      var dates = [];

      var currDate = moment(startDate).startOf("day");
      var lastDate = moment(endDate).startOf("day");

      while (currDate.add(1, "days").diff(lastDate) < 0) {
        dates.push(currDate.clone().toDate());
      }

      return dates;
    },
  },
};
</script>

<style lang="scss">
$blue: #0098db;
$lightblue: #e7f5fc;
$grey: #efefef;
html {
  -webkit-font-smoothing: auto !important;
  -moz-osx-font-smoothing: auto !important;
}
#app {
  font-family: "Droid Sans", sans-serif;
  background: white;
  border: none !important;
  padding: 0 !important;
  h1 {
    color: $blue;
  }
  .today-button {
    color: $blue;
    background-color: transparent;
    border: none;
  }
  .v-input.theme--light.v-input--selection-controls.v-input--checkbox {
    width: 20px;
    margin: 0;
    float: left;
    margin-right: 10px;
  }
  .theme--light.v-expansion-panels .v-expansion-panel-header .v-expansion-panel-header__icon .v-icon {
    color: $blue;
    font-size: 30px;
  }
  .v-event.v-event-start.v-event-end.transparent.white--text {
    width: 25px !important;
    height: 25px !important;
    float: left;
    //: 10px;
  }
  button.v-expansion-panel-header {
    font-weight: bold;
    padding-left: 0;
  }
  .v-expansion-panel-content__wrap {
    padding-left: 0;
  }
  .v-expansion-panel:before {
    box-shadow: none;
  }
  .theme--light.v-expansion-panels .v-expansion-panel {
    margin-bottom: 25px;
    border-top: 1px solid #d1d1d1;
    border-radius: 0;
  }
  .v-btn--outlined .v-btn__content .v-icon,
  .v-btn--round .v-btn__content .v-icon {
    font-size: 40px !important;
    color: #1896d3;
  }
  .theme--light.v-expansion-panels .v-expansion-panel:not(:first-child):after {
    border: none;
  }
  .ical-download {
    color: $blue;
    border: none;
    text-transform: none;
    font-size: 16px;
    line-height: 26px;
    letter-spacing: 0;
    margin-top: 20px;
  }
  .caldownload-icon {
    margin-right: 10px;
  }
  .v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none;
  }
  .v-slide-group__wrapper {
    border-bottom: 1px solid #d1d1d1;
  }
  .theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday.v-past,
  .theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday.v-future {
    color: black;
    font-size: 20px;
    font-weight: bold;
  }
  .v-calendar-weekly__head-weekday.v-present {
    font-size: 20px;
    font-weight: bold;
  }
  #kalender,
  #liste {
    padding-top: 45px;
  }
  .v-tabs:not(.v-tabs--vertical) .v-tab {
    white-space: unset;
    text-transform: none;
    letter-spacing: normal;
    color: black;
    border: 1px solid #d1d1d1;
    border-bottom: none;
    border-radius: 5px 5px 0px 0px;
  }
  .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) {
    color: $blue;
    border: none;
  }
  .v-tab:before,
  .v-tabs-slider {
    background-color: transparent;
  }
  .day {
    border-top: 1px solid #d1d1d1;
    padding: 12px 0;
    .list-date-item {
      .date {
        color: #707070;
        font-size: 12px;
        line-height: 18px;
        padding-bottom: 0;
      }
      .garbage {
        color: #707070;
        font-size: 16px;
        line-height: 19px;
        padding-bottom: 0;
      }
      .cal-export {
        padding-bottom: 0;
      }
      .ical-download {
        margin-top: 0;
      }
    }
    &:last-child {
      border-bottom: 1px solid #d1d1d1;
    }
  }
  .event-detail {
    .ical-download {
      margin-top: 0;
    }
  }
  .theme--light.v-input,
  .theme--light.v-input input,
  .theme--light.v-input textarea {
    border-radius: 0;
  }
  .theme--light.v-calendar-weekly {
    border-top: none;
  }
  .v-calendar-weekly__head {
    border-bottom: 1px solid #e0e0e0;
  }
  .theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday {
    border: none;
    background: white;
    padding-bottom: 20px;
  }
  .v-calendar-weekly__week {
    border-left: 1px solid #e0e0e0;
  }
  .theme--light.v-calendar-weekly {
    border-left: none;
  }
  ul.schadstoff {
    list-style-image: url("../src/assets/icons/schadstoff.png");
    padding-left: 50px;
    li {
      margin-left: 10px;
    }
  }
  ul.gruenschnitt {
    list-style-image: url("../src/assets/icons/gruenschnitt.png");
    padding-left: 50px;
    li {
      margin-left: 10px;
    }
  }
  ul.wertstoff {
    list-style-image: url("../src/assets/icons/wertstoff.png");
    padding-left: 50px;
    li {
      margin-left: 10px;
    }
  }
  ul.spuelung {
    list-style-image: url("../src/assets/icons/spülung.png");
    padding-left: 50px;
    li {
      margin-left: 10px;
    }
  }
  ul.spuelung-restmuell {
    list-style-image: url("../src/assets/icons/spuelung_restmuell.png");
    padding-left: 50px;
    li {
      margin-left: 10px;
    }
  }
  .v-input--selection-controls {
    padding-top: 0;
    margin-top: -3px !important;
  }
  .theme--light.v-calendar-weekly .v-calendar-weekly__day.v-outside {
    background: white;
    .v-btn__content {
      color: #d0d0d0;
    }
  }
  .v-present {
    .v-calendar-weekly__day-label {
      .v-btn {
        color: white;
        height: 30px;
        width: 30px;
      }
    }
  }
  .v-event-more {
    width: 100%;
  }
  .v-calendar.v-calendar-events .v-calendar-weekly__day {
    margin-right: 0px;
  }
  .v-expansion-panel-header {
    font-size: 16px;
    line-height: 24px;
  }
  .v-calendar-weekly__day-label {
    text-align: right;
    button {
      span {
        font-weight: bold;
      }
    }
  }
  .v-calendar-weekly__day.v-future.v-outside {
    .v-calendar-weekly__day-label {
      button {
        span {
          font-weight: normal;
        }
      }
    }
  }
  .v-calendar-weekly__day.v-future {
    font-weight: bold;
  }
  .v-autocomplete__content.v-menu__content {
    top: unset !important;
    left: 12px !important;
  }
}
#page-side,
.col-md-8.col-sm-8.col-sm-push-4.col-md-push-4 {
  padding-top: 0 !important;
}
@media screen and (max-width: 1279px) {
  #page-side,
  .col-md-8.col-sm-8.col-sm-push-4.col-md-push-4 {
    margin-top: -12px !important;
  }
}
</style>
